if (!customElements.get("cart-drawer")) {
    customElements.define(
      "cart-drawer",
      class ProductForm extends HTMLElement {
        constructor() {
          super();
          this.cartDrawerContainer = null;
          this.closeDrawer = null;
          this.cartDrawerWrapper = null;
          this.cartIcon = null;
        }
  
        connectedCallback() {
          this.cartDrawerContainer = document.querySelector(".cart-drawer-la");
          this.closeDrawer = document.querySelector(".cart-drawer-close");
          this.cartDrawerWrapper = document.querySelector(".cart-drawer-wrapper-la");
          this.cartIcon = document.querySelector(".cart-icon-mark-la");
          this.init();
          this.cartCount = document.querySelector('.cart-count-header-la')
        }
  
        init() {
  
          if (this.cartIcon) {
            this.cartIcon.addEventListener("click", this.openCartDrawer.bind(this));
          }
  
          if (this.closeDrawer) {
            this.closeDrawer.addEventListener("click", this.closeCartDrawer.bind(this));
          }
  
          if (this.cartDrawerWrapper) {
            this.cartDrawerWrapper.addEventListener("click", this.closeOnClickOutside.bind(this));
          }
  
          this.attachCartListeners();
        }
  
        openCartDrawer() {
          if (this.cartDrawerContainer) {
            this.cartDrawerContainer.classList.add("cart-drawer-active-la");
            document.body.style.overflow = 'hidden';
          }
        }
  
        closeCartDrawer() {
          if (this.cartDrawerContainer) {
            this.cartDrawerContainer.classList.remove("cart-drawer-active-la");
            document.body.style.removeProperty('overflow');
  
          }
        }
  
        closeOnClickOutside(e) {
          if (e.target === e.currentTarget && this.cartDrawerContainer) {
            this.cartDrawerContainer.classList.remove("cart-drawer-active-la");
            document.body.style.removeProperty('overflow');
  
  
          }
        }
  
        attachCartListeners() {
          document.querySelectorAll(".cart-qty-plus").forEach((button) => {
            const newButton = button.cloneNode(true);
            button.parentNode.replaceChild(newButton, button);
            newButton.addEventListener("click", (event) => {
              this.incrementQuantity(event); 
              
              const cartCountEl = this.cartCount || document.querySelector(".cart-count-header-la");
              if (cartCountEl) {
                let currentCount = parseInt(cartCountEl.textContent) || 0;
                cartCountEl.textContent = currentCount + 1;
              }
            });
          });
          
        
          document.querySelectorAll(".cart-qty-minus").forEach((button) => {
            const newButton = button.cloneNode(true);
            button.parentNode.replaceChild(newButton, button);
            newButton.addEventListener("click", (event) => {
              this.decrementQuantity(event);
          
              const cartCountEl = this.cartCount || document.querySelector(".cart-count-header-la");
              if (cartCountEl) {
                let currentCount = parseInt(cartCountEl.textContent) || 0;
                if (currentCount > 0) {
                  cartCountEl.textContent = currentCount - 1;
                }
              }
            });
          });
          
          document.querySelectorAll(".cart-remove-btn").forEach((el) => {
            const newEl = el.cloneNode(true);
            el.parentNode.replaceChild(newEl, el);
          
            newEl.addEventListener("click", (event) => {
              const button = event.currentTarget;
              const cartItem = button.closest(".cart-drawer-item");
              const qtyInput = cartItem?.querySelector(".cart-qty-input");
              const removedQty = parseInt(qtyInput?.value) || 1;
              const cartCountEl = this.cartCount || document.querySelector(".cart-count-header-la");
  
              if (cartCountEl) {
                let currentCount = parseInt(cartCountEl.textContent) || 0;
                currentCount = Math.max(0, currentCount - removedQty);
                cartCountEl.textContent = currentCount;
          
                if (currentCount === 0) {
                  cartCountEl.parentElement.classList.remove("product-form-active-la");
                  cartCountEl.textContent = "";
                }
              }
          
              this.removeCartItem(event);
            });
          });
        }
        
        async changeCartItemQuantity(lineKey, quantity) {
          try {
            const response = await fetch(window.Shopify.routes.root + "cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ id: lineKey, quantity: quantity }),
            });
  
            if (!response.ok) throw new Error("Failed to change item quantity");
  
            await this.updateCartDrawer();
          } catch (error) {
            console.error("Error changing cart quantity:", error);
          }
        }
        async removeCartItem(e) {
          e.preventDefault();
          e.stopPropagation();
        
          const cartItem = e.target.closest('.cart-drawer-item');
          if (!cartItem) return;
        
          const lineKey = cartItem.getAttribute('data-line-key');
          if (!lineKey) return;
        
          try {
            const response = await fetch(window.Shopify.routes.root + "cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ id: lineKey, quantity: 0 }),
            });
        
            if (!response.ok) throw new Error("Failed to remove item from cart.");
        
            if (window.location.pathname === "/cart") {
              window.location.reload();
            } else {
              await this.updateCartDrawer();
            }
        
          } catch (error) {
            console.log("Error removing item:", error);
          }
        }
        
        
        async updateCartDrawer() {
          try {
            const response = await fetch("/?section_id=cart-drawer-la");
            const responseText = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(responseText, "text/html");
            const newDrawerContent = doc.querySelector(".cart-drawer-la");
  
            if (this.cartDrawerContainer && newDrawerContent) {
              this.cartDrawerContainer.innerHTML = newDrawerContent.innerHTML;
              this.attachCartListeners();
            }
          } catch (error) {
            console.log("Error updating cart drawer", error);
          }
        }
  
        incrementQuantity(e) {
          const parent = e.target.closest(".cart-drawer-item");
          if (!parent) return;
  
          const input = parent.querySelector(".cart-qty-input");
          const lineKey = parent.dataset.lineKey;
          if (!input || !lineKey) return;
  
          let newQuantity = parseInt(input.value) + 1;
          input.value = newQuantity;
          this.changeCartItemQuantity(lineKey, newQuantity);
        }
  
        decrementQuantity(e) {
          const parent = e.target.closest(".cart-drawer-item");
          if (!parent) return;
  
          const input = parent.querySelector(".cart-qty-input");
          const lineKey = parent.dataset.lineKey;
          if (!input || !lineKey) return;
  
          let newQuantity = Math.max(parseInt(input.value) - 1, 1);
          input.value = newQuantity;
          this.changeCartItemQuantity(lineKey, newQuantity);
        }
      }
    );
  }
  